export default {
  'have-procedure-se': 'Perform actions on the folio to S.E.',
  'assign-products': 'Asignar inspector',
  'edit-products': 'Edit',
  'delete-invoice': 'Discard invoice'
};
